module.exports = __webpack_public_path__ + "img/logo_heimspiel.cfaf3971.png";